<template>
  <div>
    <div class="a-tab__title-block admin__a-tab">
      <h3>{{$t('form.lot.configure-specification')}}</h3>
    </div>

    <specification-config :lot="lot" :retend="retend"></specification-config>

    <auto-fill-dates :lot="lot" :retend="retend"></auto-fill-dates>

    <list-of-items :lot="lot" :retend="retend"></list-of-items>

    <total :lot="retend"></total>

    <delivery-schedule :lot="lot" :retend="retend"></delivery-schedule>

    <payments-and-parts :lot="lot" :retend="retend"></payments-and-parts>
  </div>
</template>

<script>
  import SpecificationConfig from "./sections/SpecificationConfig";
  import ListOfItems from "./sections/SpecificationTable";
  import DeliverySchedule from "./sections/DeliverySchedule";
  import AutoFillDates from "./sections/AutoFillDates";
  import PaymentsAndParts from "./sections/PaymentsAndParts";

  import Total from "@/components/purchases/lot-details/blocks/Total";
  import PermissionsMixins from "./mixins/permissions";

  export default {
    components: {
      SpecificationConfig,
      AutoFillDates,
      ListOfItems,
      Total,
      DeliverySchedule,
      PaymentsAndParts
    },

    props: {
      lot: {
        type: Object,
        required: true
      },

      retend: {
        type: Object,
        required: true
      }
    },

    mixins: [
      PermissionsMixins
    ],

    mounted() {
      if (this.canEditRetend) {
        this.showError({
          title: 'Изменение спецификации',
          error:
            'Если в партии предложение от Участника по срокам поставки принимается только в КД, то по соответствующей партии, в выделенных красным цветом полях, Вам необходимо указать дату поставки и дату приемки по качеству.' +
            '\n\n' +
            'Все остальные изменения в этой вкладке ведут к статусу "Приостановлено" (обнулается рейтинг и приведенная стоимость), который каждый участник на этапе переторжки может изменить на "Активное", подписав измененное предложение.',
        })
      }
    },

    methods: {
      async onAutoFillDeliveryRulesClick(rules) {
        const lot = _.cloneDeep(this.lot);
        lot.applyRules({
          deliveryTypes: rules
        });

        await this.updateLot(lot);
      },

      async onAutoFillPaymentTypesClick(rules) {
        const lot = _.cloneDeep(this.lot);
        lot.applyRules({
          paymentTypes: rules
        });

        await this.updateLot(lot);
      }
    }
  }
</script>

<style scoped>
</style>
